import React from 'react';
import Modal from '@omilia/modal';

import ModalButtons from 'components/ModalButtons';
// @ts-ignore
import messages from 'constants/messages';
import { SContainer, SWarningText } from '../styled';

type Props = {
  onCancel: () => void;
  onResolveConflicts: () => void;
};

const ResolveConflictsModal = ({ onCancel, onResolveConflicts }: Props) => (
  <Modal
    open
    shouldCloseOnEscPress
    glyph="notification-warning"
    hasBackdrop={false}
    title={messages.VERSION_CONTROL.MERGE_MODAL.CONFLICTS_IDENTIFIED}
    variant="danger"
  >
    <SContainer>
      <div>
        <SWarningText>Warning: </SWarningText>
        {messages.VERSION_CONTROL.MERGE_MODAL.CONFLICTS_IDENTIFIED_MESSAGE}
      </div>
      <ModalButtons
        primary={{
          text: 'Resolve Conflicts',
          onClick: onResolveConflicts,
          type: 'button',
        }}
        secondary={{ text: 'Close', onClick: onCancel }}
      />
    </SContainer>
  </Modal>
);

export default ResolveConflictsModal;
